import { ImageProps } from 'types';
import src from './image.svg';

export const alienImage: ImageProps = {
  alt: 'AlienImage',
  src,
  width: 256,
};
